import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StarIcon } from '@/img/icons/elal-anonymous-star.svg';
import { buildLoginUrl } from '@/utils/LoginUrl';
import Analytics from 'arbitrip-common/client/analytics';
import ProfileStore from '@/stores/ProfileStore';

const ElalAnonymousPromotionBar = () => {
    const { t } = useTranslation();
    const loginUrl = buildLoginUrl({ filterResultsRefUrl: true });

    return (
        <div className="elal-anonymous-promotion-bar">
            <div className="elal-anonymous-promotion-bar-inner">
                <StarIcon />

                <span>
                    {t('ElalAnonymousBanner.Description')}{' '}
                    <strong>
                        <a href={loginUrl} onClick={() => Analytics.actions.user.loginClicked(ProfileStore.getProfile())}>
                            {t('ElalAnonymousBanner.Login')}
                        </a>
                        {' / '}
                        <a href={t('ElalJoinMatmidUrl')}>{t('ElalAnonymousBanner.Signup')}</a>
                    </strong>
                </span>
            </div>
        </div>
    );
};

export default ElalAnonymousPromotionBar;
